import get from 'lodash/get';

const styles = ({ margin, padding } = {}) => ({
  fieldContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm2')} ${get(margin, 'm0')} !important`,
  },
  selectField: {
    padding: `${get(padding, 'p2')} ${get(padding, 'p10')} !important`,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/GatewayBundle/List/styles.js